import React from 'react';

import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
}

export const FormVariant = ({ nodeIds }: Props) => {
  const {
    props,
    type,
    actions: { setProps },
  } = useMultiNodes([nodeIds[0] ?? ''], (node) => ({
    props: node?.data.props || {},
  }));

  return (
    <Variants
      name={props.variant || 'base'}
      componentName={type}
      onSelectVariant={(variant) => setProps(variant.conditions)}
      conditions={props.variant ? { variant: props.variant } : {}}
    />
  );
};
